import React from "react";
import { useFormikContext } from "formik";

import { Button } from "primereact/button";

function MzSubmitButton({ label,loading, disabled,  ...otherProps }) {
  const { handleSubmit } = useFormikContext();

  return <Button type="submit" loading={loading} disabled={disabled}  label={label} {...otherProps} onClick={handleSubmit} />;
}

export default MzSubmitButton;
